import Mixpanel from './handler';
import useTrackPageView from './use-track-page-view';
export { useTrackPageView };
export default Mixpanel;
